export default () => ({
  endpoint: 'https://payments.api.aspedia.io',
  location: null,
  tokenExpires: null,
  mode: 'production',
  isConnected: false,
  isConnectedExpires: null,
  isConnectedTimestamp: null,
  oAuth2State: null,
  paymentTxn: null,
  paymentInitError: false,
  paymentDetails: null,
  processingResult: null,
  processingRequest: null,
  squareCard: null,
  locations: [],
  locationsByTxnType: {},
  transactionTypes: {},
  terminalDevices: [],
  terminalDeviceCodes: [],
  selectedTerminalDeviceId: null,
  terminalPaymentProcessing: false,
  currencies: {},
  dflt_currency: '',
  site_settings: {
    recaptcha_key: null,
    recaptcha_forms: {
      Payments: false,
      StoreCreditCard: false
    },
    sms_verification: {
      Payment: false
    }
  },
  AcceleratedTransactionHandler: null
})
